import { zodResolver } from "@hookform/resolvers/zod";
import type { ComponentProps } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { enqueueSnackbar } from "../../../../../components/GlobalSnackbar/snackbarStore";
import { isSupabaseError } from "../../../../../constants/supabaseErrors";
import type AddIncidentActionModal from "./AddIncidentActionModal";
import useSubjectActionModal from "../useSubjectActionModal";
import { formSchema as formSchemaBase, FormValues } from "../types";

type Props = ComponentProps<typeof AddIncidentActionModal>;

export default function useAddIncidentActionModal(props: Props) {
  const [serverError, setServerError] = useState<string | null>(null);

  const [showDocuments, setShowDocuments] = useState(false);

  const form = useForm({
    mode: "onChange",
    defaultValues: {
      date: props.item?.date ? new Date(props.item.date) : new Date(),
      comment: props.item?.comment || "",
      documents: [],
    },
    resolver: zodResolver(formSchemaBase),
  });

  const {
    isDocumentLoading,
    isLoading,
    handleCallApi,
  } = useSubjectActionModal(
    "incident",
    props.item?.id ?? undefined,
    props.subjectId,
    form,
  );

  async function handleConfirm(data: FormValues) {
    setServerError(null);

    try {
      await handleCallApi(data);

      enqueueSnackbar(props.item ? "Incident mis à jour." : "Incident enregistré.", "success");
      props.onClose();
    } catch (error: unknown) {
      if (isSupabaseError(error)) {
        setServerError(error.message);
        return;
      }

      setServerError(
        "Une erreur est survenue",
      );
    }
  }

  const documents = form.watch("documents");

  return {
    form,
    handleConfirm,
    isLoading,
    serverError,
    isDocumentLoading,
    showDocuments: showDocuments || documents.length > 0,
    revealDocuments: () => setShowDocuments(true),
  };
}
